import { ContentDescription } from "models/content";

export const selectDescriptionByLanguage = (list: ContentDescription[], language: string): string => {
  for (let item of list) {
    if (item.language === language) {
      return item.description;
    }
  }
  return list[0].description;
};